<template>
  <div class="sn-table-item-actions d-flex flex-row">
    <div class="sn-table-item-actions--select-all d-flex flex-row">
      <v-simple-checkbox
        v-model="selected"
        v-ripple
        :indeterminate="indeterminate"
        off-icon="$snCheckBox"
        on-icon="$snCheckBoxSelected"
        indeterminate-icon="$snCheckBoxIndeterminate"
        class="sn-table-item-actions--select-all__checkbox"
      />

      <div class="sn-table-item-actions--num-selected sn-subtitle-1 sn-font-weight-regular sn-text-primary-01 text-no-wrap">
        <span>
          {{ numSelected }} selected
        </span>
      </div>

      <sn-btn
        v-for="action in shownActions"
        :key="action.id"
        type="text"
        :prepend-icon="action.icon"
        :icon-size="action.iconSize"
        :text="action.name"
        :sn-input-props_identifier="action['snInputProps_identifier']"
        class="sn-table-item-actions--item-action-btn"
        :data-cy="`table-header-${action.name.toLowerCase().replace(/\s/g, '-')}-btn`"
        :data-pendo="snInputProps_pendo + '-ActionHeaderAction'"
        :data-pendo-action="action.name"
        @click="$emit('header-action', action)"
      />

      <sn-btn
        v-if="moreActions"
        class="sn-table-item-actions--item-action-btn"
        type="text"
        text="More"
        dropdown
        :dropdown-options="moreActions"
        @click="emitHeaderMoreAction"
      />
    </div>
  </div>
</template>

<script>
import SnBtn from '~/components/snui/v2/snBtn/snBtn'
import SnInputProps from '../props/SnInputProps'

export default {
  name: 'SnTableItemActionsHeader',
  components: { SnBtn },
  props: {
    ...SnInputProps,
    headers: {
      type: Array,
      required: true
    },
    indeterminate: {
      type: Boolean,
      required: true
    },
    numSelected: {
      type: Number,
      required: true
    },
    allItemsOnPageSelected: {
      type: Boolean,
      required: true
    },
    actions: {
      type: Array,
      required: true
    }
  },
  computed: {
    selected: {
      get () { return this.allItemsOnPageSelected },
      set () { this.$emit('header-select') }
    },
    shownActions () {
      return this.actions.slice(0, 3)
    },
    moreActions () {
      if (this.actions.length < 4) return null

      return this.actions.slice(3, this.actions.length).map(action => {
        return {
          label: action.name,
          ...action
        }
      })
    }
  },
  methods: {
    emitHeaderMoreAction (action) {
      if (action.id) {
        const actionToEmit = this.actions.find(act => act.id === action.id)
        this.$emit('header-action', actionToEmit)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/css/snui';

.sn-table-item-actions {
  background-color: #F3F7F7;
  max-height: 47px;
  position: absolute;
  top: 0;
  width: calc(100% - 2px);
  z-index: 1;

  &--item-action-btn {
    margin: 0 30px;
  }

  &--num-selected {
    line-height: 48px !important;
    padding-left: 12px;
    padding-right: 22px;
  }

  &--select-all {
    width: 100%;
    align-items: center;

    &__checkbox {
      min-width: 48px;
      padding: 12px;
      width: 5%;
    }
  }
}
</style>
